import { NgModule } from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';
import {BsModalService, ModalModule, BsDatepickerModule} from 'ngx-bootstrap';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DataTablesModule} from 'angular-datatables';
import {DateTimePickerModule} from 'ng-pick-datetime';
import {SharedModule} from '../../_shared/shared.module';
import { ReportManagerService } from './report-manager.service';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { Daterangepicker } from 'ng2-daterangepicker';
import { ReportManagerComponent } from './report-manager.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ReportsComponentModule } from '../reports-component/reports-component.module';



const routes: Routes = [
  {
    path: '',
    component: ReportManagerComponent,
    data: {
      title: 'Quản lý báo cáo'
    },
  }
];
@NgModule({
  imports: [
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule
    
  ],
  declarations: [ReportManagerComponent],
  providers: [ReportManagerService]
})
export class ReportManagerModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/report-manager/report-manager.module.ts